import { useQuery } from 'react-query'

import { DeduplicationService } from '../services'

export const useDeduplicationRun = (runId: string) =>
  useQuery(['deduplication-run', runId], () => DeduplicationService.getRun(runId), {
    enabled: !!runId,
    refetchInterval: (data) => (data?.status === 'running' ? 30_000 : false),
  })
